import { render, staticRenderFns } from "./IssueTab.vue?vue&type=template&id=0e8460f0"
import script from "./IssueTab.vue?vue&type=script&lang=js"
export * from "./IssueTab.vue?vue&type=script&lang=js"
import style0 from "./IssueTab.vue?vue&type=style&index=0&id=0e8460f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports